module.exports = __webpack_public_path__ + "static/media/asp_net_development.56c9ccad.svg";